export function leftPad(value: number, length: number = 2) {
	return `000000000${value}`.slice(-1 * length);
}

export function isWhiteSpace(value: any) {
	return typeof value === "string" && value !== "" && value.trim().length === 0;
}